import { resourceManagerActions } from "../../constants/actionTypes";

const getResourceProviderListData = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_LIST_GET_DATA,
  payload: data,
});
const getResourceProviderListData_public = (data) => ({
  type: resourceManagerActions.GET_PUBLIC_CLOUD_PROVIDER_LIST,
  payload: data,
});

const setResourceProviderListData = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_DATA,
  payload: data,
});
const setResourceProviderListData_public = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_DATA_PUBLIC,
  payload: data,
});

const setResourceProviderListError = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_ERROR,
  payload: data,
});
const setResourceProviderListError_public = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_ERROR_PUBLIC,
  payload: data,
});

const deleteResourceRequest = (data) => {
  return {
    type: resourceManagerActions.DELETE_RESOURCE_REQUEST,
    payload: data,
  };
};
const deletePublicProvider = (data) => {
  return {
    type: resourceManagerActions.DELETE_PUBLIC_PROVIDER,
    payload: data,
  };
};

const deleteResourceSuccess = (data) => {
  return {
    type: resourceManagerActions.DELETE_RESOURCE_SUCCESS,
    payload: data,
  };
};

const deleteResourceError = (data) => {
  return {
    type: resourceManagerActions.DELETE_RESOURCE_ERROR,
    payload: data,
  };
};
const templateCreateRequest = (data) => ({
  type: resourceManagerActions.TEMPLATE_CREATE_REQUEST,
  data: data,
});

const templateCreateSuccess = (data) => ({
  type: resourceManagerActions.TEMPLATE_CREATE_SUCCESS,
  data: data,
});

const templateCreateError = (data) => ({
  type: resourceManagerActions.TEMPLATE_CREATE_ERROR,
  payload: data,
});

const templateEditRequest = (data) => ({
  type: resourceManagerActions.TEMPLATE_EDIT_REQUEST,
  data: data,
});

const templateEditSuccess = (data) => ({
  type: resourceManagerActions.TEMPLATE_EDIT_SUCCESS,
  data: data,
});

const setCategoryData = (data) => ({
  type: resourceManagerActions.SET_CATEGORY_DATA,
  payload: data,
});

const getCategoryData = (data) => ({
  type: resourceManagerActions.GET_CATEGORY_DATA,
  payload: data,
});

const getCategoryDataInfinteScroll = (data) => ({
  type: resourceManagerActions.GET_CATEGORY_DATA_INFINITE_SCROLL,
  payload: data,
});
const setCategoryDataInfinteScroll = (data) => ({
  type: resourceManagerActions.SET_CATEGORY_DATA_INFINITE_SCROLL,
  payload: data,
});
const resetCategoryDataInfinteScroll = (data) => ({
  type: resourceManagerActions.RESET_CATEGORY_DATA_INFINITE_SCROLL,
  payload: data,
});

const setCategoryError = (data) => ({
  type: resourceManagerActions.SET_CATEGORY_ERROR,
  payload: data,
});

const setInstanceData = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_DATA,
  payload: data,
});
const setCategoryListSearching = (data) => ({
  type: resourceManagerActions.SET_CATEGORY_LIST_SEARCHING,
  payload: data,
});

const setInstanceListSearching = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_LIST_SEARCHING,
  payload: data,
});
const resetInstanceDataInfinteScroll = (data) => ({
  type: resourceManagerActions.RESET_INSTANCE_DATA_INFINITE_SCROLL,
  payload: data,
});

const getInstanceData = (data) => ({
  type: resourceManagerActions.GET_INSTANCE_DATA,
  payload: data,
});

const getInstanceDataInfiniteScroll = (data) => ({
  type: resourceManagerActions.GET_INSTANCE_DATA_INFINITE_SCROLL,
  payload: data,
});

const setInstanceDataInfiniteScroll = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_DATA_INFINITE_SCROLL,
  payload: data,
});

const setInstanceSizeData = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_SIZE,
  payload: data,
});

const setInstanceSizeSuccess = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_SIZE_SUCESS,
  payload: data,
});

const setInstanceSizeError = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_SIZE_ERROR,
  payload: data,
});

const deleteInstanceSizeAction = (data) => ({
  type: resourceManagerActions.DELETE_INSTANCE_SIZE,
  payload: data,
});

const deleteInstanceSuccess = (data) => ({
  type: resourceManagerActions.DELETE_INSTANCE_SIZE_SUCCESS,
  payload: data,
});

const deleteInstanceError = (data) => ({
  type: resourceManagerActions.DELETE_INSTANCE_SIZE_ERROR,
  payload: data,
});

const setInstanceError = (data) => ({
  type: resourceManagerActions.SET_INSTANCE_SIZE_ERROR,
  payload: data,
});

const setVmSnapshotData = (data) => ({
  type: resourceManagerActions.SET_VM_SNAPSHOT_DATA,
  payload: data,
});

const getVmSnapshotData = (data) => ({
  type: resourceManagerActions.GET_VM_SNAPSHOT_DATA,
  payload: data,
});

const setVmSnapshotError = (data) => ({
  type: resourceManagerActions.SET_VM_SNAPSHOT_ERROR,
  payload: data,
});

const getTemplateListData = (data) => ({
  type: resourceManagerActions.TEMPLATE_LIST_GET_DATA,
  payload: data,
});

const setTemplateListData = (data) => ({
  type: resourceManagerActions.TEMPLATE_LIST_SET_DATA,
  payload: data,
});

const setTemplateListError = (data) => ({
  type: resourceManagerActions.TEMPLATE_LIST_SET_ERROR,
  payload: data,
});

const addResourceConnection = (data) => ({
  type: resourceManagerActions.ADD_RESOURCE_CONNECTION,
  payload: data,
});

const setResourceConnectionData = (data) => ({
  type: resourceManagerActions.SET_CONNECTION_DATA,
  payload: data,
});

const addResourceAccount = (data) => ({
  type: resourceManagerActions.ADD_RESOURCE_ACCOUNT,
  payload: data,
});

const addResourceAction = (data) => ({
  type: resourceManagerActions.ADD_RESOURCE_ACTION,
  payload: data,
});

const editResourceAccount = (data, id) => ({
  type: resourceManagerActions.EDIT_RESOURCE_ACCOUNT,
  payload: { data: data, id: id },
});

const editResourceAction = (data) => ({
  type: resourceManagerActions.EDIT_RESOURCE_ACTION,
  payload: data,
});

const setResourceError = (data) => ({
  type: resourceManagerActions.SET_RESOURCE_PROVIDER_ERROR,
  payload: data,
});

const addPublicCloudProviderSuccess = (data) => ({
  type: resourceManagerActions.ADD_PUBLIC_PROVIDER_SUCCESS,
  payload: data,
});

const addPublicCloudProviderError = (data) => ({
  type: resourceManagerActions.ADD_PUBLIC_PROVIDER_ERROR,
  payload: data,
});

const setTemplateData = (data) => ({
  type: resourceManagerActions.TEMPLATE_SET_DATA,
  payload: data,
});

const getTemplateData = (data) => ({
  type: resourceManagerActions.TEMPLATE_GET_DATA,
  payload: data,
});

const getPublicTemplateById = (data) => ({
  type: resourceManagerActions.TEMPLATE_GET_DATA_PUBLIC,
  payload: data,
});

const deleteTemplateRequest = (deleteData, listUrl) => ({
  type: resourceManagerActions.DELETE_TEMPLATE_REQUEST,
  deleteData: deleteData,
});
const deleteTemplateRequestPublic = (deleteData) => ({
  type: resourceManagerActions.DELETE_PUBLIC_TEMPLATE_REQUEST,
  deleteData: deleteData,
});

const deleteTemplateSuccess = (data) => ({
  type: resourceManagerActions.DELETE_TEMPLATE_SUCCESS,
  payload: data,
});

const uploadLogo = (data) => ({
  type: resourceManagerActions.UPLOAD_LOGO,
  payload: data,
});

const setUploadedLogoData = (data) => ({
  type: resourceManagerActions.SET_LOGO_DATA,
  payload: data,
});

const setUploadLogoError = (data) => ({
  type: resourceManagerActions.UPLOAD_LOGO_ERROR,
  payload: data,
});

const publishTemplate = (data) => ({
  type: resourceManagerActions.PUBLISH_TEMPLATE,
  payload: data,
});

const publishPooledTemplate = (data) => ({
  type: resourceManagerActions.PUBLISH_POOLED_TEMPLATE,
  payload: data,
});

const setPublishTemplateError = (data) => ({
  type: resourceManagerActions.PUBLISH_TEMPLATE_ERROR,
  payload: data,
});

const publishTemplateAction = (data) => ({
  type: resourceManagerActions.PUBLISH_TEMPLATE_ACTION,
  payload: data,
});

const toggleVtEnabled = (id, data) => ({
  type: resourceManagerActions.TOGGLE_VT_ENABLED,
  payload: { id, data },
});

const toggleVtEnabledSuccess = (data) => ({
  type: resourceManagerActions.TOGGLE_VT_ENABLED_SUCCESS,
  payload: data,
});

const toggleVtEnabledError = (error) => ({
  type: resourceManagerActions.TOGGLE_VT_ENABLED_ERROR,
  payload: error,
});

const getResourceProviderDetails = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_GET_DETAILS,
  payload: data,
});
const getResourceProviderDetailsPublic = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_GET_DETAILS_PUBLIC,
  payload: data,
});

const getPublicTemplateList = (data) => ({
  type: resourceManagerActions.GET_PUBLIC_TEMPLATE_LIST,
  payload: data,
});

const setResourceProviderDetails = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_SET_DETAILS,
  payload: data,
});

const setResourceProviderError = (data) => ({
  type: resourceManagerActions.RESOURCE_PROVIDER_SET_ERROR,
  payload: data,
});

const templateExportRequest = (data) => ({
  type: resourceManagerActions.TEMPLATE_EXPORT_REQUEST,
  data: data,
});

const templateExportSuccess = (data) => ({
  type: resourceManagerActions.TEMPLATE_EXPORT_SUCCESS,
  data: data,
});

const clearTemplateExport = () => ({
  type: resourceManagerActions.CLEAR_TEMPLATE_EXPORT,
});

const templateExportError = (data) => ({
  type: resourceManagerActions.TEMPLATE_EXPORT_ERROR,
  data: data,
});

const templateRecoverRequest = (data) => ({
  type: resourceManagerActions.TEMPLATE_RECOVER_REQUEST,
  data: data,
});

const templateRecoverSuccess = (data) => ({
  type: resourceManagerActions.TEMPLATE_RECOVER_SUCCESS,
  data: data,
});

const templateRecoverError = (data) => ({
  type: resourceManagerActions.TEMPLATE_RECOVER_ERROR,
  data: data,
});

const getVCenterResources = (data) => ({
  type: resourceManagerActions.GET_VCENTER_RESOURCES,
  data: data,
});

const getVCenterResourcesNetwork = (data) => ({
  type: resourceManagerActions.GET_VCENTER_RESOURCES_NETWORK,
  data: data,
});
const setVMnamesList = (data) => ({
  type: resourceManagerActions.SET_VM_NAMES_LIST,
  data: data,
});
const setVMSnapshotNameList = (data) => ({
  type: resourceManagerActions.SET_VM_SNAPSHOT_NAMES_LIST,
  data: data,
});

const setVMNetworksList = (data) => ({
  type: resourceManagerActions.SET_VM_NETWORK_LIST,
  data: data,
});
const setVmnamesListLoading = (data) => ({
  type: resourceManagerActions.SET_VM_NAMES_LIST_LOADING,
  data: data,
});
const setVMSnapshotNameListLoading = (data) => ({
  type: resourceManagerActions.SET_VM_SNAPSHOT_NAMES_LIST_LOADING,
  data: data,
});

const setVMNetworkListLoading = (data) => ({
  type: resourceManagerActions.SET_VM_NETWORK_LIST_LOADING,
  data: data,
});

const setVMBaseFolderListLoading = (data) => ({
  type: resourceManagerActions.SET_VM_FOLDER_LIST_LOADING,
  data: data,
});

const addPublicCloudProvider = (data) => ({
  type: resourceManagerActions.ADD_PUBLIC_CLOUD_PROVIDER,
  data: data,
});
const editPublicCloudProvider = (data) => ({
  type: resourceManagerActions.EDIT_PUBLIC_CLOUD_PROVIDER,
  data: data,
});
const patchPublicCloudProvider = (data) => ({
  type: resourceManagerActions.PATCH_PUBLIC_CLOUD_PROVIDER,
  data: data,
});
const getPublicCloudProviderList = (data) => ({
  type: resourceManagerActions.GET_PUBLIC_CLOUD_PROVIDER_LIST,
  data: data,
});
const listAfterPatchPublicProvider = (data) => ({
  type: resourceManagerActions.LIST_AFTER_PATCH_PUBLIC_PROVIDER,
  payload: data,
});

const createPublicTemplateAction = (data) => ({
  type: resourceManagerActions.PUBLIC_TEMPLATE_CREATE_REQUEST,
  data: data,
});
const editPublicTemplateAction = (data) => ({
  type: resourceManagerActions.PUBLIC_TEMPLATE_EDIT_REQUEST,
  data: data,
});
const patchPublicTemplateAction = (data) => ({
  type: resourceManagerActions.PUBLIC_TEMPLATE_PATCH_REQUEST,
  data: data,
});

const setCloudConnectLoading = (data) => ({
  type: resourceManagerActions.SET_CLOUD_CONNECT_LOADING,
  payload: data,
});

const connectCloudProvider = (data) => ({
  type: resourceManagerActions.CLOUD_CONNECT_PROVIDER,
  payload: data,
});

const connectCloudProviderSuccess = (data) => ({
  type: resourceManagerActions.CLOUD_CONNECT_PROVIDER_SUCCESS,
  payload: data,
});

const connectCloudProviderError = (data) => ({
  type: resourceManagerActions.CLOUD_CONNECT_PROVIDER_ERROR,
  payload: data,
});

// Account Details Action
const publicAccountDetailsAction = (data) => ({
  type: resourceManagerActions.GET_ACCOUNT_DETAILS_ACTION,
  payload: data,
});
const publicAccountDetailsSuccess = (data) => ({
  type: resourceManagerActions.GET_ACCOUNT_DETAILS_SUCCESS,
  payload: data,
});
const publicAccountDetailsError = (data) => ({
  type: resourceManagerActions.GET_ACCOUNT_DETAILS_ERROR,
  payload: data,
});
const publicAccountDetailsReset = (data) => ({
  type: resourceManagerActions.GET_ACCOUNT_DETAILS_RESET,
  payload: data,
});

// Cleaning Jobs Action
const cleaningJobsAction = (data) => ({
  type: resourceManagerActions.GET_CLEANING_JOBS_ACTION,
  payload: data,
});
const cleaningJobsSuccess = (data) => ({
  type: resourceManagerActions.GET_CLEANING_JOBS_SUCCESS,
  payload: data,
});
const cleaningJobsError = (data) => ({
  type: resourceManagerActions.GET_CLEANING_JOBS_ERROR,
  payload: data,
});
const cleaningJobsReset = (data) => ({
  type: resourceManagerActions.GET_CLEANING_JOBS_RESET,
  payload: data,
});

// AWS Usage Action
const AWSUsageAction = (data) => ({
  type: resourceManagerActions.GET_AWS_USAGE_ACTION,
  payload: data,
});
const AWSUsageSuccess = (data) => ({
  type: resourceManagerActions.GET_AWS_USAGE_SUCCESS,
  payload: data,
});
const AWSUsageError = (data) => ({
  type: resourceManagerActions.GET_AWS_USAGE_ERROR,
  payload: data,
});
const AWSUsageReset = (data) => ({
  type: resourceManagerActions.GET_AWS_USAGE_RESET,
  payload: data,
});

// Maintenance Session Action
const MaintenanceSessionAction = (data) => ({
  type: resourceManagerActions.MAINTENANCE_SESSION_ACTION,
  payload: data,
});
const MaintenanceSessionSuccess = (data) => ({
  type: resourceManagerActions.MAINTENANCE_SESSION_SUCCESS,
  payload: data,
});
const MaintenanceSessionError = (data) => ({
  type: resourceManagerActions.MAINTENANCE_SESSION_ERROR,
  payload: data,
});
const MaintenanceSessionReset = (data) => ({
  type: resourceManagerActions.MAINTENANCE_SESSION_RESET,
  payload: data,
});

// Mark As Clean Action
const MarkAsCleanAction = (data) => ({
  type: resourceManagerActions.MARK_AS_CLEAN_ACTION,
  payload: data,
});
const MarkAsCleanSuccess = (data) => ({
  type: resourceManagerActions.MARK_AS_CLEAN_SUCCESS,
  payload: data,
});
const MarkAsCleanError = (data) => ({
  type: resourceManagerActions.MARK_AS_CLEAN_ERROR,
  payload: data,
});
const MarkAsCleanReset = () => ({
  type: resourceManagerActions.MARK_AS_CLEAN_RESET,
});

export {
  getResourceProviderListData,
  setResourceProviderListData,
  setResourceProviderListError,
  addResourceConnection,
  setResourceConnectionData,
  addResourceAccount,
  addResourceAction,
  editResourceAccount,
  editResourceAction,
  getTemplateListData,
  setTemplateListData,
  setTemplateListError,
  setResourceError,
  deleteResourceRequest,
  deleteResourceSuccess,
  deleteResourceError,
  templateCreateRequest,
  templateCreateSuccess,
  templateEditRequest,
  templateEditSuccess,
  setCategoryData,
  setCategoryError,
  getCategoryData,
  setInstanceData,
  getInstanceData,
  setInstanceError,
  setVmSnapshotData,
  getVmSnapshotData,
  setVmSnapshotError,
  uploadLogo,
  setUploadedLogoData,
  setUploadLogoError,
  publishTemplate,
  setPublishTemplateError,
  publishTemplateAction,
  setTemplateData,
  getTemplateData,
  deleteTemplateRequest,
  deleteTemplateSuccess,
  toggleVtEnabled,
  toggleVtEnabledSuccess,
  toggleVtEnabledError,
  getResourceProviderDetails,
  setResourceProviderDetails,
  setResourceProviderError,
  templateExportRequest,
  templateExportSuccess,
  clearTemplateExport,
  templateExportError,
  templateRecoverRequest,
  templateRecoverSuccess,
  templateRecoverError,
  setVMSnapshotNameList,
  setVMnamesList,
  getVCenterResources,
  setVmnamesListLoading,
  setVMSnapshotNameListLoading,
  setVMNetworkListLoading,
  setVMBaseFolderListLoading,
  setVMNetworksList,
  getVCenterResourcesNetwork,
  addPublicCloudProvider,
  setResourceProviderListData_public,
  setResourceProviderListError_public,
  getPublicCloudProviderList,
  getResourceProviderListData_public,
  editPublicCloudProvider,
  patchPublicCloudProvider,
  listAfterPatchPublicProvider,
  deletePublicProvider,
  getPublicTemplateList,
  getResourceProviderDetailsPublic,
  deleteTemplateRequestPublic,
  createPublicTemplateAction,
  editPublicTemplateAction,
  patchPublicTemplateAction,
  getPublicTemplateById,
  connectCloudProvider,
  setCloudConnectLoading,
  connectCloudProviderError,
  connectCloudProviderSuccess,
  templateCreateError,
  addPublicCloudProviderError,
  addPublicCloudProviderSuccess,
  setInstanceListSearching,
  setCategoryListSearching,
  getCategoryDataInfinteScroll,
  setCategoryDataInfinteScroll,
  getInstanceDataInfiniteScroll,
  setInstanceDataInfiniteScroll,
  resetCategoryDataInfinteScroll,
  resetInstanceDataInfinteScroll,
  publishPooledTemplate,
  setInstanceSizeData,
  setInstanceSizeSuccess,
  setInstanceSizeError,
  deleteInstanceSizeAction,
  deleteInstanceSuccess,
  deleteInstanceError,
  publicAccountDetailsAction,
  publicAccountDetailsSuccess,
  publicAccountDetailsError,
  publicAccountDetailsReset,
  cleaningJobsAction,
  cleaningJobsSuccess,
  cleaningJobsError,
  cleaningJobsReset,
  AWSUsageAction,
  AWSUsageSuccess,
  AWSUsageError,
  AWSUsageReset,
  MaintenanceSessionAction,
  MaintenanceSessionSuccess,
  MaintenanceSessionError,
  MaintenanceSessionReset,
  MarkAsCleanAction,
  MarkAsCleanSuccess,
  MarkAsCleanError,
  MarkAsCleanReset,
};
